
import React from "react";
import styled from "styled-components";

export const AgencyLogo = (props) => {
  const { agencyId } = props;
  let name = "";
  if (agencyId === "80801005354") {
    name = "izu";
  } else if (agencyId === "3080101003809") {
    name = "fuji";
  } else if (agencyId === "3080101013304") {
    name = "tokai";
  } else {
    name = "null";
  }
  const url = `/logo_${name}.png`;

  return <SImg src={url} alt="agencyLogo" />;
};

const SImg = styled.img`
  height: 40px;
  width: 100px;
`;
